import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    paperContainer: {
        width: '100%',
        maxWidth: 'calc(100% - 10px)',
        overflow: 'auto',
        height: '100%',
        flexGrow: 1,
    },
    commitmentImageDiv: {
        'padding': '10px',
        '& div div div': {
            '@media screen and (max-width: 1100px)': {
                width: '250px',
            }
        },
        '@media screen and (max-width: 1100px)': {
            display: 'none'
        }
    },
    commitmentDataGrid: {
        'height': '100%',
        '& .dx-datagrid-headers .dx-row > td ': {
            outline: 'unset !important'
        },
        '& .dx-checkbox-container .dx-checkbox-icon ': {
            width: '20px',
            height: '18px',
            border: '2px solid #333333',
            marginBottom: '3px',
        },
        '& .dx-checkbox-checked .dx-checkbox-icon': {
            color: '#333333',
        },
        '& .dx-checkbox-indeterminate .dx-checkbox-icon::before': {
            backgroundColor: '#333333',
        },
        '& .dx-header-filter:not(.dx-header-filter-empty) ': {
            color: '#5E9ED6',
        },
    },
    commitmentHeaderFilter: {
        '& span': {
            color: '#959595 !important',
            cursor: 'pointer',
        }
    },
    grid: {
        marginTop: '10px'
    },
    lineDetailIcon: {
        cursor: 'pointer'
    },
    disabledLineDetailIcon: {
        cursor: 'default',
        fill: 'grey'
    },
});
